import {ComponentRef} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, timer} from 'rxjs';
// import scrollIntoView from 'scroll-into-view-if-needed';

import {MixinConstructor} from './mixin.define';
import {LINK_POPUP_DELAY, LinkInfo, LIST_TYPE, RESULT_LINKPOPUP, SearchParam} from '../defines/client.const';
import {DynamicComponentService} from '../services/dynamic-component/dynamic-component.service';
import {LinkPopupComponent} from '../components/link-popup/link-popup.component';
import {LayoutMgrService} from "../services/layout-mgr/layout-mgr.service";


type MultiLinkMixinType = {
  router: Router,
  dynamicSvc: DynamicComponentService,
  lm: LayoutMgrService,
};

/**
 * 단일 mixin을 사용하는 경우의 정의.
 */
export const multiLinkMixin = MultiLinkMixinFunction(
  class Parent {
    constructor(
      public router: Router,
      public dynamicSvc: DynamicComponentService,
      public lm: LayoutMgrService,
    ) {
    }
  }
);

export function MultiLinkMixinFunction<BaseType extends MixinConstructor<MultiLinkMixinType>>(BaseClass: BaseType) {
  return class extends BaseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    private elRefMultiLinkPopup: ComponentRef<LinkPopupComponent> | null = null;


    /**
     *
     * @param ids - 단어 ID 들 (콤마로 구분)
     * @param container - 링크 팝업창을 열 기준이 되는 요소
     * @param word - 링크에 표시되는 문자열
     */
    public OpenMultiLink(ids: string, word: string | null = null): Observable<RESULT_LINKPOPUP> {
      console.log('MultiLinkMixin::OpenMultiLink() : word=', ids);

      return new Observable<RESULT_LINKPOPUP>(observer => {
        if (!this.lm.vcRef) {
          observer.error('MultiLinkMixinFunction::OpenMultiLink() vcRef is null');
          return;
        }

        try {
          this.elRefMultiLinkPopup = this.dynamicSvc.createComponent(LinkPopupComponent, this.lm.vcRef);
        } catch (err) {
          console.error('MultiLinkMixin::OpenMultiLink() : Failed to create popup', err);
          observer.error(err);
          return;
        }

        /******************************************************************************************
         * 팝업창이 닫힐 때 발생하는 이벤트 이벤트 처리.
         */
        this.elRefMultiLinkPopup.instance.closePopup.subscribe((linkInfo: LinkInfo | null) => {
          console.log('MultiLinkMixin::OpenMultiLink() : linkInfo=', linkInfo);

          observer.next(RESULT_LINKPOPUP.POPUP_CLOSE);

          if (linkInfo) {
            const serial: number = new Date().getTime();
            const lenWord = linkInfo.wordIds?.length ?? 0;
            const lenDialect = linkInfo.dialectIds?.length ?? 0;
            if (lenWord + lenDialect >= 2) {
              // 단어와 지방어가 2개 이상이면 링크 페이지로 이동.
              const queryParams: SearchParam = {
                serial,
                ...(linkInfo.wordIds && {wids: linkInfo.wordIds.join(',')}), // 단어 ID
                ...(linkInfo.dialectIds && {dids: linkInfo.dialectIds.join(',')}), // 지방어 ID
              };
              this.router.navigate(['/link'], {queryParams}).then();

              observer.next(RESULT_LINKPOPUP.GOTO_DETAIL);
            } else if (linkInfo?.wordIds && lenWord === 1) {
              const id = linkInfo.wordIds[0];
              const queryParams: SearchParam = {
                serial,
                id,
                start: id,  // TODO: start 파라미터는 없이도 처리가 되도록 개선해야 함.
                l: LIST_TYPE.SERVER,
              };
              this.router.navigate(['/word'], {queryParams}).then();

              observer.next(RESULT_LINKPOPUP.GOTO_LINK);
            } else if (linkInfo?.dialectIds && lenDialect === 1) {
              const id = linkInfo.dialectIds[0];
              const queryParams: SearchParam = {
                serial,
                id,
                start: id,  // TODO: start 파라미터는 없이도 처리가 되도록 개선해야 함.
                l: LIST_TYPE.SERVER,
              };
              this.router.navigate(['/dialect'], {queryParams}).then();

              observer.next(RESULT_LINKPOPUP.GOTO_LINK);
            }
          }

          observer.complete();
          this.closeMultiLinkPopup();
        });


        /******************************************************************************************
         * 화면에 초기화 된 후 (ngAfterViewInit()) 발생하는 이벤트 처리.
         */
        this.elRefMultiLinkPopup.instance.viewInit.subscribe((nativeEl: HTMLElement) => {

          // 팝업창이 열리는 애니메이션이 끝난 뒤에 스크롤 해야 정확한 위치로 스크롤이 된다.
          timer(LINK_POPUP_DELAY).subscribe(() => {
            console.log('MultiLinkMixin::OpenMultiLink() : viewInit=', nativeEl);

            // scrollIntoView(nativeEl, {
            //   behavior: 'smooth',
            //   block: 'end',
            //   scrollMode: 'if-needed',
            // });
          });
        });

        /******************************************************************************************
         * 팝업창에 표시할 정보 설정.
         */
        const [wordIds, dialectIds] = ids.split(';').map((item) => item ? item.split(',') : []);

        this.elRefMultiLinkPopup.instance.linkInfo = {
          ...((wordIds && wordIds.length > 0) ? {wordIds} : {}),
          ...((dialectIds && dialectIds.length > 0) ? {dialectIds} : {}),
          ...(word && {word}),
        };
        this.elRefMultiLinkPopup.changeDetectorRef.detectChanges();
      });
    }

    private closeMultiLinkPopup(): void {
      if (this.elRefMultiLinkPopup) {
        this.elRefMultiLinkPopup.destroy();
        this.elRefMultiLinkPopup = null;
      }
    }

  };
}
